import ProductCard from "@/components/feature/ProductCard";
import { featuredProducts } from "@/mocks/products";

export default function FeaturedProducts() {
  return (
    <section id="featured" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <header className="text-center mb-12 md:mb-16">
          <p className="font-label text-[11px] md:text-xs tracking-[0.28em] uppercase text-foreground-500 mb-3">
            Featured Collection
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-light tracking-[0.16em] uppercase text-foreground-950">
            Online Jewelry Store
          </h2>
        </header>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 md:gap-x-8 md:gap-y-14">
          {featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href="#story"
            className="bg-primary-500 hover:bg-primary-600 text-foreground-950 font-label text-xs tracking-[0.24em] uppercase px-8 py-3.5 rounded-md transition-colors whitespace-nowrap"
          >
            View All Products
          </a>
        </div>
      </div>
    </section>
  );
}